import { render, staticRenderFns } from "./SaleOrderQuery.vue?vue&type=template&id=06f4c979"
import script from "./SaleOrderQuery.vue?vue&type=script&lang=js"
export * from "./SaleOrderQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports